var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.335,
    height: 12.208,
    viewBox: "0 0 11.335 12.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1350.909,430.164v-3.056a.433.433,0,0,1,.432-.432h1.748a.437.437,0,0,1,.436.436v3.052a.436.436,0,0,0,.436.436h3.488a.436.436,0,0,0,.436-.436v-6.105a.432.432,0,0,0-.128-.307l-1.18-1.18V419.7a.436.436,0,0,0-.436-.436h-.872a.436.436,0,0,0-.436.436v1.127l-2.307-2.308a.437.437,0,0,0-.617,0h0l-5.231,5.231a.436.436,0,0,0-.128.309v6.1a.436.436,0,0,0,.436.436h3.488A.436.436,0,0,0,1350.909,430.164Z",
    transform: "translate(-1346.55 -418.392)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.be8644bda35fb86e73de7e8480ff97a7.svg";
export { ForwardRef as ReactComponent };